import script from "./LicenseplateCorrection.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseplateCorrection.vue?vue&type=script&setup=true&lang=js"

import "./LicenseplateCorrection.vue?vue&type=style&index=0&id=58120770&scoped=true&lang=css"

import exportComponent from "E:\\web\\duty_new_2\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_9f64b88eef0ad2be2f27cb0deb411dda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58120770"]])

export default __exports__